import { memo } from 'react';

/**
 * ジャンプボタングループコンポーネント
 * 該当傷病、目次、凡例、別表へのジャンプボタンを表示
 * ※ memo化により、propsが変更されない限り再レンダリングを防止
 */
const JumpButtonGroup = memo(({
  activeJumpButton,
  canJumpDisease,
  canJumpContents,
  canJumpLegend,
  canJumpAppendix,
  onJumpCurrentDisease,
  onJumpContents,
  onJumpLegend,
  onJumpAppendix,
}) => {
  return (
    <div className="pdf-control-group jump-group">
      <div className="hikiuke-meyasu-jump-buttons">
        <button
          type="button"
          className={`jump-button ${activeJumpButton === 'disease' && canJumpDisease ? 'active' : ''}`}
          onClick={onJumpCurrentDisease}
          disabled={!canJumpDisease}
        >
          該当傷病
        </button>
        <button
          type="button"
          className={`jump-button ${activeJumpButton === 'contents' && canJumpContents ? 'active' : ''}`}
          onClick={onJumpContents}
          disabled={!canJumpContents}
        >
          目次
        </button>
        <button
          type="button"
          className={`jump-button ${activeJumpButton === 'legend' && canJumpLegend ? 'active' : ''}`}
          onClick={onJumpLegend}
          disabled={!canJumpLegend}
        >
          凡例
        </button>
        <button
          type="button"
          className={`jump-button ${activeJumpButton === 'appendix' && canJumpAppendix ? 'active' : ''}`}
          onClick={onJumpAppendix}
          disabled={!canJumpAppendix}
        >
          別表
        </button>
      </div>
    </div>
  );
});

export default JumpButtonGroup;
